import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import authReducer from './auth_reducer'
import feesReducer from './fees_reducer'
import groupsReducer from './groups_reducer'
import statisticsReducer from './statistics_reducer'
import personsReducer from './persons_reducer'
import settingsReducer from './settings_reducer'
import tbReducer from './tb_reducer'

const rootReducer = combineReducers({
  form,
  auth: authReducer,
  fees: feesReducer,
  groups: groupsReducer,
  statistics: statisticsReducer,
  person: personsReducer,
  settings: settingsReducer,
  tb: tbReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js